import React from "react";
import PropTypes from "prop-types";
import styles from "components/grid/cell-formatters/type-cell-formatter.scss";

export const TypeCellFormatter = ({ value }) => {
  const { type, tooltip } = getTypeValue(value);
  return (
    <div className={ styles.container }>
      { type }
      <div className={ styles.tooltip }>{tooltip}</div>
    </div>
  );
};

TypeCellFormatter.propTypes = {
  value: PropTypes.string.isRequired
};

const getTypeValue = (value) => {
  switch (value) {
    case "receipt":
      return { type: "R", tooltip: "Receipt" };
    case "other":
      return { type: "O", tooltip: "Other Document" };
    case "business-card":
      return { type: "B", tooltip: "Business Card" };
    default:
      return { type: "?", tooltip: "Unknown document type" };
  }
};



// WEBPACK FOOTER //
// ./src/js/components/grid/cell-formatters/type-cell-formatter.jsx